$('#burgerNavSearchInput').on("keyup", () => {
    let searchContent = $('#burgerNavSearchInput').val().toLowerCase();
    let collections = $(".burgerNavChildCollectionTitle");
    let parentCollection = $(".burgerNavCollections");
    parentCollection = jQuery.makeArray(parentCollection);
    collections = jQuery.makeArray(collections);

    // Hide children collections that doesn't match the search
    collections.forEach(collection => {
        if(!$(collection).text().toLowerCase().includes(searchContent) && searchContent.length > 1) {
            $(collection).hide()
        } else {
            $(collection).show()
        }
    });

    // Check & hide parent collection if all childrens are hidden (Unless it matches parent collection's title)
    parentCollection.forEach((pCollection) => {
        let childrens = jQuery.makeArray($(pCollection).children());
        // Remove one because the first child is the Main collection
        let childrendsCount = childrens.length - 1;
        let i = 0;
        childrens.forEach((child) => {
            if($(child).hasClass('burgerNavChildCollectionTitle') && $(child).is(':hidden')  && !$(pCollection).text().toLowerCase().includes(searchContent)) {
                i++;
                if (i === childrendsCount) $(pCollection).hide();
            } else {
                $(pCollection).show();
            }
        })
    })
})